import { api } from '@/plugins/api'

const state = {
    Traductions: [],
    Langue: 'fr'
}

const getters = {
    GET_BY_ID: (state) => (id) => {
        let traduction = state.Traductions.find(t => t.Id == id)
        if (traduction) {
            return traduction.Text
        }
    }
}

const mutations = {
    SET_TRADUCTIONS(state, traductions) {
        state.Traductions = traductions
    },
    SET_LANGUE(state, langue) {
        state.Langue = langue
    }
}

const actions = {
    ChargerTraductions(store) {
        api.get('traduction/all/' + state.Langue)
            .then(function (response) {
                store.commit('SET_TRADUCTIONS', response.data)
            })
            .catch(function (err) {
                // eslint-disable-next-line no-console
                console.log(err)
            })
    }
}

export default ({
    namespaced: true,
    state: state,
    mutations: mutations,
    getters: getters,
    actions: actions
})